import Typography from '@/common/components/base/typography/Typography';
import { CorrectiveSelectedImageBarType } from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/correctiveSelectedImageBar/CorrectiveSelectedImageBar.type';
import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export const CorrectiveSelectedImageBar = ({
  removePoint,
  id,
  title,
  editable,
}: CorrectiveSelectedImageBarType) => {
  return (
    <Box
      key={id}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={12}
      py={8}
      bg="gray-3"
      borderRadius={8}
      width={'100%'}
    >
      <Flex alignItems="center">
        <Typography textStyle="b2">{title}</Typography>
      </Flex>
      {editable && (
        <CloseIcon
          stroke={token('colors.black-3')}
          onClick={() => removePoint?.(id)}
        />
      )}
    </Box>
  );
};
